"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./FormField.css");

require("../../shared/styles/spacing.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function FormLabel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      labelPosition = _ref.labelPosition,
      margin = _ref.margin,
      fullWidth = _ref.fullWidth,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "children", "label", "labelPosition", "margin", "fullWidth"]);

  var cssClasses = ['st_label', "st_label--" + labelPosition];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  if (fullWidth) cssClasses.push('st_label--fullWidth');
  return (
    /*#__PURE__*/

    /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
    _react["default"].createElement("label", _extends({
      className: cssClasses.join(' ')
    }, otherProps), " ", /*#__PURE__*/_react["default"].createElement("div", {
      className: "st_label__text"
    }, label), children)
  );
}

FormLabel.propTypes = {
  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** what to display as the label content */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,

  /** position of label relative to input */
  labelPosition: _propTypes["default"].oneOf(['top', 'left', 'right', 'bottom']),

  /** margin for label, if any */
  margin: utils.spacing.marginProps,

  /** whether label should take up all available space */
  fullWidth: _propTypes["default"].bool
};
FormLabel.defaultProps = {
  className: null,
  labelPosition: 'top',
  margin: null,
  fullWidth: false
};
var _default = FormLabel;
exports["default"] = _default;